const KEY = 'mv_state'

/**
 * Returns full value of MV Store
 * @return {object}
 */
export const getLocalState = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY))
  } catch (err) {
    return null
  }
}

/**
 * Caches review data
 * @param {object} data Object where keys are review IDs and values are review data
 * Like:
 * {
 *   1: { ...attributes }
 * }
 * @return {object} Value of the first object passed
 */
export const setLocalState = (data) => {
  const state = getLocalState() || { ratings: {} }
  const { ratings } = state
  const updatedRatings = { ...ratings, ...data }
  localStorage.setItem(KEY, JSON.stringify({
    ...state,
    ratings: updatedRatings,
  }))
  return Object.values(data)[0]
}

/**
 * Given recipe id, get matching review from state
 * @param  {int|string} id Recipe ID
 * @return {object}
 */
export const getInitialState = (id) => {
  const state = getLocalState()

  // If we don't have state or don't have ratings, return null
  if (!state || !state.ratings) {
    return null
  }

  // Get values of previous ratings
  const ratings = Object.values(state.ratings)

  // Get the rating that matches the id that we passed
  const rating = ratings.find(({ creation }) => creation == id) // eslint-disable-line

  // Only use the rating data if it has an active handshake
  if (rating && rating.handshake && rating.handshake.trim() !== "") {
    return rating
  }

  return null
}
